import { Component, OnInit, Input , ElementRef , ViewChild,  OnChanges  } from '@angular/core';
//import { DomSanitizer, SafeHtml, SafeStyle, SafeScript, SafeUrl, SafeResourceUrl } from '@angular/platform-browser';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss'],
})
export class VideoComponent implements OnInit {

  @Input() url : string;


  @ViewChild('idsrc', {static: true}) idsrc : ElementRef;
  

  url2 : any;
  video1 : boolean = false;
  //@ViewChild('idframe', {static: false}) idsrc : ElementRef;
  
  constructor(public sanitizer:DomSanitizer) {}

  ngOnInit() {}

  //ngOnChanges(changes: {[propKey: string]: SimpleChange}) {
    ngOnChanges() {
      
 
   
      
     //alert(this.url);
     //let urly = this.url;//‡"https://www.youtube.com/embed/WZcISqf5_6w";
    if(this.url=="video1")
          this.video1 = true;
    else { 

     this.url2 = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
  
    let balise = '<iframe width="640" height="360" src="' + this.url2 +'" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';

    this.idsrc.nativeElement.innerHTML = balise;
    }
     
  }


}
